import { CreateSearchConfig, SearchResults } from "../../types/coveo-types";
import { NativeDataFetcher } from "@sitecore-jss/sitecore-jss";

/**
 * Executes a new search on the Coveo platform.
 *
 */
export const createSearch = async (
  data: CreateSearchConfig,
): Promise<SearchResults | CreateSearchConfig> => {
  const fetcher = new NativeDataFetcher({
    headers: [
      ["Content-Type", "application/json"],
      ["Authorization", `Bearer ${process.env.NEXT_PUBLIC_CoveoSearchToken}`],
    ],
  });

  return await fetcher
    .post<SearchResults>(
      `https://platform.cloud.coveo.com/rest/organizations/${process.env.NEXT_PUBLIC_CoveoOrganizationId}/commerce/v2/search?trackingId=${process.env.NEXT_PUBLIC_CoveoTrackingId}`,
      data,
    )
    .then((response) => {
      return response.data;
    })
    .catch((e) => {
      console.log(e);
      return data;
    });
};
